import React, { memo, useMemo, useCallback } from "react";
import { v4 } from "uuid";
import classNames from "classnames";
import "./TableInfoRow.scss";

import UniversalCheckbox from "components/uiComponents/UniversalCheckbox";
import TableInfoCell from "components/uiComponents/TableInfoCell";

import { numberWithCommas } from "utils/helpers";

const TableInfoRow = memo(
  ({
    lines,
    lineElements,
    id,
    paintCeilData,
    checked,
    onCheckChange,
    unitsArr,
  }) => {
    const restCells = useMemo(() => {
      return lines.map((el, index) => {
        if (index !== 0) {
          let elUpd = el;

          if (typeof el === 'number') {
            if (el % 1 !== 0) {
              elUpd = numberWithCommas(el.toFixed(2));
            }
          }

          const currentColor = paintCeilData?.rowItemIndex === index && !checked ? paintCeilData.color : ''

          return (
            <TableInfoCell key={v4()}>
              <div className="table-info-row__cell_content" style={{color: currentColor}}>
                <span>
                  {elUpd}&nbsp;
                </span>

                {!!el &&
                  <span>{unitsArr?.[index]?.unit}</span>
                }

                {!!el && unitsArr?.[index]?.subUnit &&
                  <span className="table-info-row__cell_sup">{unitsArr?.[index]?.subUnit}</span>
                }
              </div>
            </TableInfoCell>
          )
        }
      });
    }, [lines, unitsArr, paintCeilData]);

    const handleChange = useCallback((isChecked) => {
      onCheckChange(isChecked, lineElements, id);
    }, [lineElements, id, onCheckChange]);

    const firstCeilColor = paintCeilData?.rowItemIndex === 0 && !checked ? paintCeilData.color : ''

    return (
      <div
        className={classNames({
          "table-info-row": true,
          "table-info-row--checked": !!checked,
        })}
      >
        <TableInfoCell>
          <div className="table-info-row__cell_content" style={{color: firstCeilColor}}>
            <UniversalCheckbox
              label={lines[0]}
              name="tableheader"
              onChange={handleChange}
              checked={!!checked}
            />
          </div>
        </TableInfoCell>

        {restCells}
      </div>
    );
  }
);

export default TableInfoRow;
